import React from 'react';
import { Spinner } from 'reactstrap';
import { useAlertRules } from '../../Hooks/useAlertRules';
import { RULE_FIELDS, TYPE_LABELS } from './alertRuleFields';

/**
 * Panel de detectores.
 *
 * Sustituye a los tres recuadros decorativos ("Reglas", "Canales",
 * "Umbrales") que sólo servían de enlace al mismo modal. Ahora se listan los
 * detectores reales con su interruptor: apagar uno detiene la generación de
 * alertas nuevas, no borra las abiertas.
 *
 * El número de parámetros sale de `RULE_FIELDS`, que es la misma fuente de la
 * que el modal arma el formulario: si se agrega un campo a un detector, el
 * conteo se mueve solo.
 */
const AlertConfigCard = ({ onOpenConfig }) => {
  const { rules, isLoading, error, toggleRule, isSaving } = useAlertRules();

  const activeCount = rules.filter((rule) => rule.active).length;

  return (
    <div className="ui-card mb-3">

      <div className="ui-card__head" style={{ marginBottom: 6 }}>
        <h3 className="ui-card__title">Detectores</h3>
        {rules.length > 0 && (
          <span style={{ color: '#8A91AE', fontSize: 12 }}>
            {activeCount} de {rules.length} activos
          </span>
        )}
      </div>

      <p className="ui-hint" style={{ marginTop: 0, marginBottom: 16 }}>
        Cada detector expone sus propios parámetros. Apagarlo detiene la
        generación de alertas nuevas, no borra las abiertas.
      </p>

      {isLoading && (
        <div className="text-center py-4">
          <Spinner size="sm" />
        </div>
      )}

      {!isLoading && error && (
        <div className="ui-note ui-note--danger">
          No se pudieron cargar los detectores.
        </div>
      )}

      {!isLoading && !error && (
        <div className="d-flex flex-column gap-2">
          {rules.map((rule) => {
            const params = RULE_FIELDS[rule.type]?.length ?? 0;

            return (
              <div
                key={rule.code}
                className={`ui-detector${rule.active ? '' : ' ui-detector--off'}`}
              >
                <div className="ui-detector__row">
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="ui-detector__name">
                      {rule.name || TYPE_LABELS[rule.type] || rule.type}
                    </div>
                    <div className="ui-detector__code">{rule.code}</div>
                  </div>

                  <button
                    type="button"
                    role="switch"
                    aria-checked={Boolean(rule.active)}
                    aria-label={`Activar ${rule.name || rule.code}`}
                    className={`ui-switch${rule.active ? ' ui-switch--on' : ''}`}
                    disabled={isSaving}
                    onClick={() => toggleRule(rule.id || rule._id)}
                  >
                    <span className="ui-switch__knob" />
                  </button>
                </div>

                <div className="ui-detector__foot">
                  <span>
                    {params} {params === 1 ? 'parámetro' : 'parámetros'}
                  </span>
                  <button
                    type="button"
                    className="ui-link"
                    style={{ fontSize: 11.5 }}
                    onClick={() => onOpenConfig(rule.code)}
                  >
                    Configurar
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

    </div>
  );
};

export default AlertConfigCard;
